document.addEventListener('DOMContentLoaded', function () {
  if (!customElements.get('side-panel-links')) {
    class ProductSidePanelLinks extends HTMLElement {
      constructor() {
        super();
        this.drawer = document.getElementById('Product-Information-Drawer');
        this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
        this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
        this.body = document.body;
      }

      connectedCallback() {
        this.setupObservers();
      }

      setupObservers() {
        const allLinks = document.querySelectorAll('.side-panel-links--link');

        allLinks.forEach((item) => {
          item.addEventListener('click', () => {
            const index = parseInt(item.getAttribute('data-id'), 10);
            if (isNaN(index)) return;

            this.body.classList.add('open-cc');
            this.drawer.classList.add('active');

            const tabComponent = document.querySelector('side-panel-content-tabs');
            if (tabComponent) {
              tabComponent.toggleActiveClass(index); // ✅ proper tab handling
            }
          });
        });
      }
    }

    customElements.define('side-panel-links', ProductSidePanelLinks);
  }
});